import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { TextField } from "../../../components/TextField";
import Divider from "../../../components/menu/Divider";
import { Score } from "../../../components/Score";
import { ScoreBarChart } from "../../../components/ScoreBarChart";
import { Image } from "primereact/image";
import { openPDF } from "../../../utils/open_pdf_base64";
import pdfImagem from '../../../assets/pdfImagens.png';   
 
export default function AutoLaudo({
  data,
  title
}: {
  data: any
  title: any
}) {
  const { t } = useTranslation();
  const getValue = (value?: string): string => value || "Não informado";
 
  const getValueScore = (value:string) => {
    if(value === 'A'){
      return '950';
    }
    if(value === 'B'){
      return '750';
    }
 
    if(value === 'C'){
      return '550';
    }
 
    if(value === 'D'){
      return '350';
    }
 
    if(value === 'E'){
      return '150';
    }
    return '0';
  }
 
  const topMarkers = [
    '0', '10', '40', '60', '80', '100'
  ];
 
  const bottomLabels = [
    "Baixa",
    "Média",
    "Alta"
  ];
 
  const getRange = (pontuacao:number) => {
        
    if(pontuacao >= 400 && pontuacao < 500){
        return 'REGULAR'
    }
 
    if(pontuacao >= 500 && pontuacao < 600){
        return 'BOM'
    }
    if(pontuacao >= 600){
        return 'OTIMO'
    }
 
    return 'RUIM'
  }
 
  return (
    <Panel header={title} style={{width:'98%'}}>
 
       <Panel header="Resumo do veículo">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 2fr 2fr" }}>
            <div><img src={'data:image/jpeg;base64, ' + data?.BIN_ESTADUAL.LOGO_FABRICANTE.IMAGEM_BASE64}></img></div>
            {data?.BIN_NACIONAL ? (
            <div>
              <TextField
                label="Marca/Modelo"
                value={getValue(data?.BIN_NACIONAL.MARCA_MODELO)}
              />
              <TextField
                label="Ano Fabricação/Modelo"
                value={getValue(data?.BIN_NACIONAL.ANO_FABRICACAO +'/'+ data?.BIN_NACIONAL.ANO_MODELO)}
              />
              <TextField
                label="Cor"
                value={getValue(data?.BIN_NACIONAL.COR_VEICULO)}
              />
              <TextField
                label="Número motor"
                value={getValue(data?.BIN_NACIONAL.NUMERO_MOTOR)}
              />
            </div>
            ) : 
            (
              <div>
              <TextField
                label="Marca/Modelo"
                value={getValue(data?.BIN_ESTADUAL.MARCA_MODELO)}
              />
              <TextField
                label="Ano Fabricação/Modelo"
                value={getValue(data?.BIN_ESTADUAL.ANO_FABRICACAO +'/'+ data?.BIN_ESTADUAL.ANO_MODELO)}
              />
              <TextField
                label="Cor"
                value={getValue(data?.BIN_ESTADUAL.COR_VEICULO)}
              />
              <TextField
                label="Número motor"
                value={getValue(data?.BIN_ESTADUAL.NUMERO_MOTOR)}
              />
            </div>
            )}
            {data?.BIN_NACIONAL ? (
            <div>
              <TextField
                label="Placa"
                value={getValue(data?.BIN_NACIONAL.PLACA)}
              />
              <TextField
                label="Chassi"
                value={getValue(data?.BIN_NACIONAL.CHASSI)}
              />
              <TextField
                label="Combustível"
                value={getValue(data?.BIN_NACIONAL.COMBUSTIVEL)}
              />
            </div>
            ) : 
            (
              <div>
                <TextField
                  label="Placa"
                  value={getValue(data?.BIN_ESTADUAL.PLACA)}
                />
                <TextField
                  label="Chassi"
                  value={getValue(data?.BIN_ESTADUAL.CHASSI)}
                />
                <TextField
                  label="Combustível"
                  value={getValue(data?.BIN_ESTADUAL.COMBUSTIVEL)}
                />
              </div>
            )}
          </section>
      </Panel>
      <br></br>
      {data?.ANALISE_KILOMETRAGEM && (
       <Panel header="Análise Quilometragem">
          <h5>Estimativa</h5>
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr" }}>
          
          <div>
            <TextField
                label="KM Baixa"
                value={getValue(data?.ANALISE_KILOMETRAGEM.ESTIMATIVA.BAIXA)}
              />
          </div>
          <div>
            <TextField
                label="KM Média"
                value={getValue(data?.ANALISE_KILOMETRAGEM.ESTIMATIVA.MEDIA)}
              />
          </div>
          <div>
            <TextField
                label="KM Alta"
                value={getValue(data?.ANALISE_KILOMETRAGEM.ESTIMATIVA.ALTA)}
              />
          </div>
          </section>
      </Panel>
      )}
      <br></br>
      {data?.RENAJUD && (
      <Panel header="Renajud">
        <DataTable value={data?.RENAJUD.OCORRENCIAS}>
          <Column field="DATA" header="Data"></Column>
          <Column field="CODIGO_JUDICIAL" header="Código"></Column>
          <Column field="MARCA_MODELO" header="Marca/modelo"></Column>
          <Column field="PROCESSO" header="Processo"></Column>
          <Column body={(item:any)=>item.ANO_DE_FABRICACAO + '/' + item.ANO_MODELO} header="Ano Fabricação/modelo"></Column>
          <Column field="PLACA" header="Placa"></Column>
          <Column field="RENAVAM" header="Renavam"></Column>
          <Column field="RESTRICOES" header="Restrição"></Column>
          <Column field="TRIBUNAL" header="Tribunal"></Column>
          <Column field="TIPO_BLOQUEIO" header="Tipo bloqueio"></Column>
        </DataTable>
      </Panel>
      )}
      <br></br>
      {data?.RENAINF && (
      <Panel header="Ranainf">
        <DataTable value={data?.RENAINF.OCORRENCIAS}>
          <Column field="DATA_INFRACAO" header="Data"></Column>
          <Column field="INFRACAO" header="Infração"></Column>
          <Column field="AUTO_INFRACAO" header="Auto Infração"></Column>
          <Column field="ORGAO_ATUADOR" header="Órgão"></Column>
          <Column field="DETALHES.DADOS_NOTIFICACAO.VALOR_INFRACAO" header="Valor"></Column>
        </DataTable>
      </Panel>
      )}
      <br></br>
      <Panel header="Alertas">
        <DataTable value={data?.ALERTAS.OCORRENCIAS}>
          <Column field="DESCRICAO" header="Descrição"></Column>
          <Column field="MENSAGEM" header="Mensagem"></Column>
          <Column field="SEVERIDADE" header="Serveridade"></Column>
        </DataTable>
      </Panel>
      <br></br>
      {data?.CALCULO_VALORIZACAO && (
        <Panel header="Calculo valorização">
          {data?.CALCULO_VALORIZACAO.CALCULOS.map((item:any) => (
            <div>
              <DataTable value={item.VALORES}>
                <Column field="MES" header="Mês"></Column>
                <Column field="ANO" header="Ano"></Column>
                <Column field="VALOR_INTEGRAL" header="Valor"></Column>
                <Column field="VALOR_DIFERENCA" header="Diferença"></Column>
                <Column field="PORCENTAGEM_DIFERENCA" header="Percentual diferença"></Column>
              </DataTable>
              <br></br>
            </div>
          ))}
          
        </Panel>
      )}
      <br></br>
      {data?.PROPRIETARIO_ATUAL_VEICULO && (
       <Panel header="Proprietário Atual">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
          
            <div>
              <TextField
                label="Marca/Modelo"
                value={getValue(data?.PROPRIETARIO_ATUAL_VEICULO.MARCA_MODELO)}
              />
              <TextField
                label="Ano Fabricação/Modelo"
                value={getValue(data?.PROPRIETARIO_ATUAL_VEICULO.ANO_FABRICACAO +'/'+ data?.PROPRIETARIO_ATUAL_VEICULO.ANO_MODELO)}
              />
              <TextField
                label="Cor"
                value={getValue(data?.PROPRIETARIO_ATUAL_VEICULO.COR_VEICULO)}
              />
              <TextField
                label="Número motor"
                value={getValue(data?.PROPRIETARIO_ATUAL_VEICULO.MOTOR)}
              />
              <TextField
                label="Data"
                value={getValue(data?.PROPRIETARIO_ATUAL_VEICULO.DATA_ATUALIZACAO)}
              />
              <h4>Proprietário</h4>
              <TextField
                label="Documento"
                value={getValue(data?.PROPRIETARIO_ATUAL_VEICULO.PROPRIETARIO_DOCUMENTO)}
              />
              <TextField
                label="Nome"
                value={getValue(data?.PROPRIETARIO_ATUAL_VEICULO.PROPRIETARIO_NOME)}
              />
            </div>
            <div>
              <TextField
                label="Placa"
                value={getValue(data?.PROPRIETARIO_ATUAL_VEICULO.PLACA)}
              />
              <TextField
                label="Chassi"
                value={getValue(data?.PROPRIETARIO_ATUAL_VEICULO.CHASSI)}
              />
              <TextField
                label="Combustível"
                value={getValue(data?.PROPRIETARIO_ATUAL_VEICULO.COMBUSTIVEL)}
              />
              <TextField
                label="Município"
                value={getValue(data?.PROPRIETARIO_ATUAL_VEICULO.MUNICIPIO)}
              />
              <TextField
                label="UF"
                value={getValue(data?.PROPRIETARIO_ATUAL_VEICULO.UF)}
              />
            </div>
          </section>
      </Panel>
      )}
      <br></br>
       <Panel header="Informação do veículo">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            {data?.BIN_NACIONAL && (
              <div>
                <h3>Informação Nacional</h3>
                <TextField
                  label="Marca/Modelo"
                  value={getValue(data?.BIN_NACIONAL.MARCA_MODELO)}
                />
                <TextField
                  label="Ano Fabricação/Modelo"
                  value={getValue(data?.BIN_NACIONAL.ANO_FABRICACAO +'/'+ data?.BIN_NACIONAL.ANO_MODELO)}
                />
                <TextField
                  label="Categoria"
                  value={getValue(data?.BIN_NACIONAL.CATEGORIA_VEICULO)}
                />
                <TextField
                  label="Tipo veículo"
                  value={getValue(data?.BIN_NACIONAL.TIPO_VEICULO)}
                />
                <TextField
                  label="Placa"
                  value={getValue(data?.BIN_NACIONAL.PLACA)}
                />
                <TextField
                  label="Renavam"
                  value={getValue(data?.BIN_NACIONAL.RENAVAM)}
                />
                <TextField
                  label="Chassi"
                  value={getValue(data?.BIN_NACIONAL.CHASSI)}
                />
                <TextField
                  label="Situação"
                  value={getValue(data?.BIN_NACIONAL.SITUACAO)}
                />
                <TextField
                  label="Cambio"
                  value={getValue(data?.BIN_NACIONAL.CAIXA_CAMBIO)}
                />
                <TextField
                  label="Capacidade de carga"
                  value={getValue(data?.BIN_NACIONAL.CAPACIDADE_CARGA)}
                />
                <TextField
                  label="Cilindradas"
                  value={getValue(data?.BIN_NACIONAL.CILINDRADA)}
                />
                <TextField
                  label="CMT"
                  value={getValue(data?.BIN_NACIONAL.CMT)}
                />
                <TextField
                  label="Combustível"
                  value={getValue(data?.BIN_NACIONAL.COMBUSTIVEL)}
                />
                <TextField
                  label="Cor"
                  value={getValue(data?.BIN_NACIONAL.COR_VEICULO)}
                />
                <TextField
                  label="Espécie"
                  value={getValue(data?.BIN_NACIONAL.ESPECIE_VEICULO)}
                />
                <TextField
                  label="Emplacamento"
                  value={getValue(data?.BIN_NACIONAL.DATA_EMPLACAMENTO)}
                />
                <TextField
                  label="Município"
                  value={getValue(data?.BIN_NACIONAL.MUNICIPIO)}
                />
                <TextField
                  label="UF"
                  value={getValue(data?.BIN_NACIONAL.UF)}
                />
                <TextField
                  label="N. Carroceria"
                  value={getValue(data?.BIN_NACIONAL.NUMERO_CARROCERIA)}
                />
                <TextField
                  label="Número DI"
                  value={getValue(data?.BIN_NACIONAL.NUMERO_DI)}
                />
                <TextField
                  label="Data DI"
                  value={getValue(data?.BIN_NACIONAL.DATA_REGISTRO_DI)}
                />
                <TextField
                  label="Número Eixo Auxiliar"
                  value={getValue(data?.BIN_NACIONAL.NUMERO_EIXO_AUXILIAR)}
                />
                <TextField
                  label="Número Eixo Traseiro"
                  value={getValue(data?.BIN_NACIONAL.NUMERO_EIXO_TRASEIRO)}
                />
                <TextField
                  label="Quantidade Eixos"
                  value={getValue(data?.BIN_NACIONAL.NUMERO_EIXOS)}
                />
                <TextField
                  label="Número motor"
                  value={getValue(data?.BIN_NACIONAL.NUMERO_MOTOR)}
                />
                <TextField
                  label="PBT"
                  value={getValue(data?.BIN_NACIONAL.PBT)}
                />
                <TextField
                  label="Potência"
                  value={getValue(data?.BIN_NACIONAL.POTENCIA_VEICULO)}
                />
                <TextField
                  label="Procedência"
                  value={getValue(data?.BIN_NACIONAL.PROCEDENCIA)}
                />
                <TextField
                  label="Quantidade passageiros"
                  value={getValue(data?.BIN_NACIONAL.QUANTIDADE_PASSAGEIROS)}
                />
                <TextField
                  label="Situação chassi"
                  value={getValue(data?.BIN_NACIONAL.SITUACAO_CHASSI)}
                />
                <TextField
                  label="Tipo carroceria"
                  value={getValue(data?.BIN_NACIONAL.TIPO_CARROCERIA)}
                />
                <TextField
                  label="Tipo Doc. faturado"
                  value={getValue(data?.BIN_NACIONAL.TIPO_DOCUMENTO_DO_FATURADO)}
                />
                <TextField
                  label="Tipo Doc. importador"
                  value={getValue(data?.BIN_NACIONAL.TIPO_DOCUMENTO_IMPORTADOR)}
                />
                <TextField
                  label="Número importador"
                  value={getValue(data?.BIN_NACIONAL.NUMERO_IDENTIFICACAO_IMPORTADOR)}
                />
                <TextField
                  label="Tipo Operação importação"
                  value={getValue(data?.BIN_NACIONAL.TIPO_OPERACAO_IMPORTACAO_VEICULO)}
                />
                <TextField
                  label="Montagem"
                  value={getValue(data?.BIN_NACIONAL.TIPO_MONTAGEM)}
                />
                <TextField
                  label="Número Faturado"
                  value={getValue(data?.BIN_NACIONAL.NUMERO_IDENTIFICACAO_FATURADO)}
                />
                <TextField
                  label="UF Faturamento"
                  value={getValue(data?.BIN_NACIONAL.UF_FATURAMENTO)}
                />
                <TextField
                  label="Data limite restrição trib."
                  value={getValue(data?.BIN_NACIONAL.DATA_LIMITE_RESTRICAO_TRIBUTARIA)}
                />
                <TextField
                  label="Data atualização"
                  value={getValue(data?.BIN_NACIONAL.DATA_ATUALIZACAO)}
                />
                <TextField
                  label="Código órgão SRF"
                  value={getValue(data?.BIN_NACIONAL.CODIGO_DO_ORGAO_SRF)}
                />
                <TextField
                  label="Data emissão CRLV"
                  value={getValue(data?.BIN_NACIONAL.DATA_EMISSAO_CRLV)}
                />
                <TextField
                  label="Data Emissão Último CRV"
                  value={getValue(data?.BIN_NACIONAL.DATA_EMISSAO_ULTIMO_CRV)}
                />
                <Divider></Divider>
                <h5>Restrições Nacional</h5>
                {data?.BIN_NACIONAL.RESTRICOES.MENSAGENS_RESTRICOES && data?.BIN_NACIONAL.RESTRICOES.MENSAGENS_RESTRICOES.length > 0 && (
                  <div>
                    {data?.BIN_NACIONAL.RESTRICOES.MENSAGENS_RESTRICOES.map((item:any) => (
                        <TextField
                            label="Restrição"
                            value={getValue(item.MENSAGEM)}
                        />
                    ))}
                </div>
                )}
              {data?.BIN_NACIONAL.PROPRIETARIO && (
                <div>
                    <h5>Proprietário</h5>
                    <TextField
                        label="CPF/CNPJ"
                        value={getValue(data?.BIN_NACIONAL.PROPRIETARIO.DOCUMENTO)}
                    />
                    <TextField
                        label="Nome"
                        value={getValue(data?.BIN_NACIONAL.PROPRIETARIO.NOME)}
                    />
                </div>
              )}
              </div>    
            )}
            <div>
              <h3>Informação Estadual</h3>
              <TextField
                label="Marca/Modelo"
                value={getValue(data?.BIN_ESTADUAL.MARCA_MODELO)}
              />
              <TextField
                label="Ano Fabricação/Modelo"
                value={getValue(data?.BIN_ESTADUAL.ANO_FABRICACAO +'/'+ data?.BIN_ESTADUAL.ANO_MODELO)}
              />
               <TextField
                label="Categoria"
                value={getValue(data?.BIN_ESTADUAL.CATEGORIA_VEICULO)}
              />
              <TextField
                label="Tipo veículo"
                value={getValue(data?.BIN_ESTADUAL.TIPO_VEICULO)}
              />
              <TextField
                label="Placa"
                value={getValue(data?.BIN_ESTADUAL.PLACA)}
              />
              <TextField
                label="Renavam"
                value={getValue(data?.BIN_ESTADUAL.RENAVAM)}
              />
              <TextField
                label="Chassi"
                value={getValue(data?.BIN_ESTADUAL.CHASSI)}
              />
              <TextField
                label="Situação"
                value={getValue(data?.BIN_ESTADUAL.SITUACAO)}
              />
              <TextField
                label="Cambio"
                value={getValue(data?.BIN_ESTADUAL.CAIXA_CAMBIO)}
              />
              <TextField
                label="Capacidade de carga"
                value={getValue(data?.BIN_ESTADUAL.CAPACIDADE_CARGA)}
              />
              <TextField
                label="Cilindradas"
                value={getValue(data?.BIN_ESTADUAL.CILINDRADA)}
              />
              <TextField
                label="CMT"
                value={getValue(data?.BIN_ESTADUAL.CMT)}
              />
              <TextField
                label="Combustível"
                value={getValue(data?.BIN_ESTADUAL.COMBUSTIVEL)}
              />
              <TextField
                label="Cor"
                value={getValue(data?.BIN_ESTADUAL.COR_VEICULO)}
              />
               <TextField
                label="Espécie"
                value={getValue(data?.BIN_ESTADUAL.ESPECIE_VEICULO)}
              />
              <TextField
                label="Emplacamento"
                value={getValue(data?.BIN_ESTADUAL.DATA_EMPLACAMENTO)}
              />
              <TextField
                label="Município"
                value={getValue(data?.BIN_ESTADUAL.MUNICIPIO)}
              />
              <TextField
                label="UF"
                value={getValue(data?.BIN_ESTADUAL.UF)}
              />
              <TextField
                label="N. Carroceria"
                value={getValue(data?.BIN_ESTADUAL.NUMERO_CARROCERIA)}
              />
              <TextField
                label="Número DI"
                value={getValue(data?.BIN_ESTADUAL.NUMERO_DI)}
              />
              <TextField
                label="Data DI"
                value={getValue(data?.BIN_ESTADUAL.DATA_REGISTRO_DI)}
              />
              <TextField
                label="Número Eixo Auxiliar"
                value={getValue(data?.BIN_ESTADUAL.NUMERO_EIXO_AUXILIAR)}
              />
              <TextField
                label="Número Eixo Traseiro"
                value={getValue(data?.BIN_ESTADUAL.NUMERO_EIXO_TRASEIRO)}
              />
             <TextField
                label="Quantidade Eixos"
                value={getValue(data?.BIN_ESTADUAL.NUMERO_EIXOS)}
              />
              <TextField
                label="Número motor"
                value={getValue(data?.BIN_ESTADUAL.NUMERO_MOTOR)}
              />
              <TextField
                label="PBT"
                value={getValue(data?.BIN_ESTADUAL.PBT)}
              />
              <TextField
                label="Potência"
                value={getValue(data?.BIN_ESTADUAL.POTENCIA_VEICULO)}
              />
                <TextField
                label="Procedência"
                value={getValue(data?.BIN_ESTADUAL.PROCEDENCIA)}
              />
              <TextField
                label="Quantidade passageiros"
                value={getValue(data?.BIN_ESTADUAL.QUANTIDADE_PASSAGEIROS)}
              />
              <TextField
                label="Situação chassi"
                value={getValue(data?.BIN_ESTADUAL.SITUACAO_CHASSI)}
              />
              <TextField
                label="Tipo carroceria"
                value={getValue(data?.BIN_ESTADUAL.TIPO_CARROCERIA)}
              />
              <TextField
                label="Tipo Doc. faturado"
                value={getValue(data?.BIN_ESTADUAL.TIPO_DOCUMENTO_DO_FATURADO)}
              />
              <TextField
                label="Tipo Doc. importador"
                value={getValue(data?.BIN_ESTADUAL.TIPO_DOCUMENTO_IMPORTADOR)}
              />
              <TextField
                label="Número importador"
                value={getValue(data?.BIN_ESTADUAL.NUMERO_IDENTIFICACAO_IMPORTADOR)}
              />
              <TextField
                label="Tipo Operação importação"
                value={getValue(data?.BIN_ESTADUAL.TIPO_OPERACAO_IMPORTACAO_VEICULO)}
              />
              <TextField
                label="Montagem"
                value={getValue(data?.BIN_ESTADUAL.TIPO_MONTAGEM)}
              />
              <TextField
                label="Número Faturado"
                value={getValue(data?.BIN_ESTADUAL.NUMERO_IDENTIFICACAO_FATURADO)}
              />
              <TextField
                label="UF Faturamento"
                value={getValue(data?.BIN_ESTADUAL.UF_FATURAMENTO)}
              />
              <TextField
                label="Data limite restrição trib."
                value={getValue(data?.BIN_ESTADUAL.DATA_LIMITE_RESTRICAO_TRIBUTARIA)}
              />
              <TextField
                label="Data atualização"
                value={getValue(data?.BIN_ESTADUAL.DATA_ATUALIZACAO)}
              />
              <TextField
                label="Código órgão SRF"
                value={getValue(data?.BIN_ESTADUAL.CODIGO_DO_ORGAO_SRF)}
              />
              <Divider></Divider>
              {data?.BIN_ESTADUAL.INFORMACOES_AVULSAS && data?.BIN_ESTADUAL.INFORMACOES_AVULSAS.length > 0 && (
                <div>
                  {data?.BIN_ESTADUAL.INFORMACOES_AVULSAS.map((item:any) => (
                      <TextField
                          label={item.DESCRICAO}
                          value={getValue(item.VALOR)}
                      />
                  ))}
              </div>
              )}
              <h5>Restrições Estadual</h5>
              {data?.BIN_ESTADUAL.RESTRICOES.MENSAGENS_RESTRICOES && data?.BIN_ESTADUAL.RESTRICOES.MENSAGENS_RESTRICOES.length > 0 && (
                <div>
                  {data?.BIN_ESTADUAL.RESTRICOES.MENSAGENS_RESTRICOES.map((item:any) => (
                      <TextField
                          label="Restrição"
                          value={getValue(item.MENSAGEM)}
                      />
                  ))}
              </div>
              )}
              <h5>Multas e débitos Estadual</h5>
              <TextField
                  label="Débitos DPVAT"
                  value={getValue(data?.BIN_ESTADUAL.RESTRICOES.DPVAT.VALOR_PENDENCIA ? data?.BIN_ESTADUAL.RESTRICOES.DPVAT.VALOR_PENDENCIA : 'NADA CONSTA')}
              />
              <TextField
                  label="Débitos IPVA"
                  value={getValue(data?.BIN_ESTADUAL.RESTRICOES.IPVA.VALOR_PENDENCIA ? data?.BIN_ESTADUAL.RESTRICOES.IPVA.VALOR_PENDENCIA : 'NADA CONSTA')}
              />
              <TextField
                  label="Débitos Licenciamento"
                  value={getValue(data?.BIN_ESTADUAL.RESTRICOES.LICENCIAMENTO.VALOR_PENDENCIA ? data?.BIN_ESTADUAL.RESTRICOES.LICENCIAMENTO.VALOR_PENDENCIA : 'NADA CONSTA')}
              />
              <TextField
                  label="Débitos Multa"
                  value={getValue(data?.BIN_ESTADUAL.RESTRICOES.MULTAS.VALOR_PENDENCIA ? data?.BIN_ESTADUAL.RESTRICOES.MULTAS.VALOR_PENDENCIA : 'NADA CONSTA')}
              />
            </div>
          </section>
        </Panel>
 
        <br />
      <br></br>
      {data?.GRAVAME && (
      <Panel header="Gravames">
        <DataTable value={data?.GRAVAME.OCORRENCIAS}>
          <Column field="DATA_INCLUSAO_GRAVAME" header="Data"></Column>
           <Column field="PLACA" header="Placa"></Column>
            <Column field="RENAVAM" header="Renavam"></Column>
          <Column field="NOME_AGENTE" header="Informante"></Column>
          <Column field="DOC_AGENTE" header="Documento Informante"></Column>
          <Column field="NUMERO_CONTRATO" header="Contrato"></Column>
          <Column field="STATUS_VEICULO" header="Status veículo"></Column>
          <Column field="STATUS_GRAVAME" header="Status"></Column>
          <Column field="NOME_FINANCIADO" header="Nome Financiado"></Column>
          <Column field="DOC_FINANCIADO" header="Documento Financiado"></Column>
        </DataTable>
      </Panel>
      )}
      <br></br>
      {data?.RECALL && (
      <Panel header="Recall">
        <DataTable value={data?.RECALL.OCORRENCIAS}>
          <Column field="DATA_INICIO" header="Data"></Column>
          <Column field="DEFEITO" header="Defeito"></Column>
          <Column field="MENSAGEM_COMPLETA" header="Mensagem"></Column>
          <Column field="RISCO" header="Risco"></Column>
        </DataTable>
      </Panel>
      )}
      <br></br>
       <Panel header="Ficha técnica">
          <h4>Informações técnicas</h4>
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Marca/Modelo"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.MARCA_MODELO)}
              />
              <TextField
                label="Ano Fabricação/Modelo"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.ANO_FABRICACAO +'/'+ data?.FICHA_TECNICA_VEICULAR.ANO_MODELO)}
              />
              <TextField
                label="Cor"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.COR_VEICULO)}
              />
              <TextField
                label="Número motor"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.NUMERO_MOTOR)}
              />
              <TextField
                label="Suspensão dianteira"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.SUSPENSAO_DIANTEIRA)}
              />
              <TextField
                label="Freio dianteira"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.FREIO_DIANTEIRO)}
              />
              <TextField
                label="Motor"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.MOTOR)}
              />
              <TextField
                label="Direção"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.DIRECAO)}
              />
            </div>
            <div>
              <TextField
                label="Placa"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.PLACA)}
              />
              <TextField
                label="Chassi"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.CHASSI)}
              />
              <TextField
                label="Combustível"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.COMBUSTIVEL)}
              />
              <TextField
                label="Suspensão traseira"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.SUSPENSAO_TRASEIRA)}
              />
              <TextField
                label="Freio traseiro"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.FREIO_TRASEIRO)}
              />
              <TextField
                label="Cambio"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.CAMBIO)}
              />
              <TextField
                label="Quantidade passageiros"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.QUANTIDADE_PASSAGEIROS)}
              />
            </div>
          </section>
          <h4>Medidas</h4>
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Altura"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.MEDIDAS.ALTURA)}
              />
              <TextField
                label="Comprimento"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.MEDIDAS.COMPRIMENTO)}
              />
              <TextField
                label="Largura"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.MEDIDAS.LARGURA)}
              />
              <TextField
                label="Entre eixos"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.MEDIDAS.ENTRE_EIXOS)}
              />
            </div>
            <div>
              <TextField
                label="Peso"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.MEDIDAS.PESO)}
              />
              <TextField
                label="Porta malas"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.MEDIDAS.PORTA_MALAS)}
              />
              <TextField
                label="Tanque combustível"
                value={getValue(data?.FICHA_TECNICA_VEICULAR.MEDIDAS.TANQUE_COMBUSTIVEL)}
              />
        
            </div>
          </section>
           <h4>Equipamentos</h4>
          <DataTable value={data?.FICHA_TECNICA_VEICULAR.EQUIPAMENTOS}>
            <Column field="DESCRICAO" header="Descrição"></Column>
            <Column field="DISPONIBILIDADE" header="Disponibilidade"></Column>
          </DataTable>
      </Panel>
      <br></br>
      {data?.LEILAO && data?.LEILAO.QUANTIDADE_OCORRENCIAS !== '0' && (
        <Panel header="Leilão">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Placa"
                value={getValue(data?.LEILAO.DADOS_VEICULO.PLACA)}
              />
              <TextField
                label="Categoria"
                value={getValue(data?.LEILAO.DADOS_VEICULO.CATEGORIA)}
              />
              <TextField
                label="Marca/Modelo"
                value={getValue(data?.LEILAO.DADOS_VEICULO.MARCA_MODELO)}
              />
              <TextField
                label="Motor"
                value={getValue(data?.LEILAO.DADOS_VEICULO.MOTOR)}
              />
            </div>
            <div>
              <TextField
                label="Chassi"
                value={getValue(data?.LEILAO.DADOS_VEICULO.CHASSI)}
              />
              <TextField
                label="Combustível"
                value={getValue(data?.LEILAO.DADOS_VEICULO.COMBUSTIVEL)}
              />
              <TextField
                label="Cor"
                value={getValue(data?.LEILAO.DADOS_VEICULO.COR)}
              />
              <TextField
                label="Ano Fabricação/Modelo"
                value={getValue(data?.LEILAO.DADOS_VEICULO.ANO_FABRICACAO +'/'+ data?.LEILAO.DADOS_VEICULO.ANO_MODELO)}
              />
        
            </div>
          </section>
          <DataTable value={data?.LEILAO.OCORRENCIAS}>
            <Column field="DATA_LEILAO" header="Data"></Column>
            <Column field="LEILOEIRO" header="Leiloeiro"></Column>
            <Column field="LOTE" header="Lote"></Column>
            <Column field="COMITENTE" header="Comitente"></Column>
          </DataTable>
          {data?.LEILAO.SCORE && (
            <div className="grid" style={{gap:'5rem'}}>
              <div className="col">
                <h5>Score danos</h5>
                <Score score={getValueScore(data?.LEILAO.SCORE.PONTUACAO)} range={getRange(Number(getValueScore(data?.LEILAO.SCORE.PONTUACAO)))} />
              </div>
              <div className="col">
                <h5>Score referência</h5>
                <ScoreBarChart
                        score={data?.LEILAO.SCORE.PERCENTUAL_SOBRE_TABELA_REFERENCIA}
                        topMarkers={topMarkers}
                        bottomLabels={bottomLabels}
                        reverse={false}
                        maxScore={100}
                      />
              </div>
              <div className="col">
                <h5>Score Aceitação</h5>
                <ScoreBarChart
                        score={data?.LEILAO.SCORE.ACEITACAO}
                        topMarkers={topMarkers}
                        bottomLabels={bottomLabels}
                        reverse={false}
                        maxScore={100}
                      />
              </div>
            </div>
            
          )}
 
        </Panel>
      )} 
      <br></br>
      {data?.LEILAO_CONJUGADO && (
        <div>
        {data?.LEILAO_CONJUGADO.OCORRENCIAS.filter((i:any) => i.DADOS_VEICULO && i.DADOS_VEICULO.PLACA).map((item:any)=> (
 
          <div>
          <Panel header={item.NOME_BASE}>
            <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
              <div>
                <TextField
                  label="Placa"
                  value={getValue(item.DADOS_VEICULO.PLACA)}
                />
                <TextField
                  label="Categoria"
                  value={getValue(item.DADOS_VEICULO.CATEGORIA)}
                />
                <TextField
                  label="Marca/Modelo"
                  value={getValue(item.DADOS_VEICULO.MARCA_MODELO)}
                />
                <TextField
                  label="Motor"
                  value={getValue(item.DADOS_VEICULO.MOTOR)}
                />
              </div>
              <div>
                <TextField
                  label="Chassi"
                  value={getValue(item.DADOS_VEICULO.CHASSI)}
                />
                <TextField
                  label="Combustível"
                  value={getValue(item.DADOS_VEICULO.COMBUSTIVEL)}
                />
                <TextField
                  label="Cor"
                  value={getValue(item.DADOS_VEICULO.COR)}
                />
                <TextField
                  label="Ano Fabricação/Modelo"
                  value={getValue(item.DADOS_VEICULO.ANO_FABRICACAO +'/'+ item.DADOS_VEICULO.ANO_MODELO)}
                />
          
              </div>
            </section>
            <DataTable value={item.OCORRENCIAS}>
              <Column field="DATA_LEILAO" header="Data"></Column>
              <Column field="LEILOEIRO" header="Leiloeiro"></Column>
              <Column field="LOTE" header="Lote"></Column>
              <Column field="COMITENTE" header="Comitente"></Column>
            </DataTable>
            {item.SCORE && (
              <div className="grid" style={{gap:'5rem'}}>
                <div className="col">
                  <h5>Score danos</h5>
                  <Score score={getValueScore(item.SCORE.PONTUACAO)} range={getRange(Number(getValueScore(item.SCORE.PONTUACAO)))} />
                </div>
                <div className="col">
                  <h5>Score referência</h5>
                  <ScoreBarChart
                          score={item.SCORE.PERCENTUAL_SOBRE_TABELA_REFERENCIA}
                          topMarkers={topMarkers}
                          bottomLabels={bottomLabels}
                          reverse={false}
                          maxScore={100}
                        />
                </div>
                <div className="col">
                  <h5>Score Aceitação</h5>
                  <ScoreBarChart
                          score={item.SCORE.ACEITACAO}
                          topMarkers={topMarkers}
                          bottomLabels={bottomLabels}
                          reverse={false}
                          maxScore={100}
                        />
                </div>
              </div>
              
            )}
 
          </Panel>
          <br></br>
          </div>
        )) }
        </div>
      )} 
      <br></br>
      {data?.CSV && (
        <Panel header="Laudo">
          <div className="grid">
            {data?.CSV.OCORRENCIAS.map((item:any) => (
              <div className="col">
                {item.IMAGE_FILE ? (
                    <Image
                        src={'data:image/jpeg;base64, ' + item.IMAGE_FILE.FILE_BASE64}
                        alt="Image"
                        zoomSrc={'data:image/jpeg;base64, ' + item.IMAGE_FILE.FILE_BASE64}
                        preview
                        imageStyle={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                ): (
                    <Image
                        src={pdfImagem}
                        alt="Image"
                        zoomSrc={pdfImagem}
                        preview
                        imageStyle={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                        }}
                    />
                )}
                {item.PDF_FILE && (
                    <button
                        style={{
                            background: "transparent",
                            border: "none",
                            textDecoration: "underline",
                            cursor: "pointer",
                            color: "blue",
                        }}
                        onClick={() => openPDF(item.PDF_FILE.FILE_BASE64)}
                        >
                        Abrir PDF
                    </button>
                )}
              </div> 
            ))}
          </div>
        </Panel>
      )} 
      <br></br>
      {data?.HISTORICO_ROUBO_FURTO && data?.HISTORICO_ROUBO_FURTO.OCORRENCIAS && (
        <Panel header="Histórico de roubo/furto">
          <DataTable value={data?.HISTORICO_ROUBO_FURTO.OCORRENCIAS}>
              <Column field="DATA_OCORRENCIA" header="Data"></Column>
              <Column field="BOLETIM" header="Boletim"></Column>
              <Column field="CHASSI" header="Chassi"></Column>
              <Column field="MARCA_MODELO" header="Marca/modelo"></Column>
              <Column body={(item:any)=>item.ANO_FABRICACAO + '/' + item.ANO_MODELO} header="Ano Fabricação/modelo"></Column>
              <Column field="PLACA" header="Placa"></Column>
              <Column field="CIDADE" header="Cidade"></Column>
              <Column field="UF_OCORRENCIA" header="UF"></Column>
              <Column field="IDENTIDADE_INFORMANTE" header="RG"></Column>
              <Column field="TELEFONE_CONTATO" header="Telefone"></Column>
              <Column field="NOME_INFORMANTE" header="Informante"></Column>
              
            </DataTable>
        </Panel>
      )} 
      <br></br>
      {data?.INDICIO_SINISTRO && data?.LEILAO.INDICIO_SINISTRO !== '0' && (
        <Panel header="Indício de sinistro">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Descrição"
                value={getValue(data?.INDICIO_SINISTRO.DESCRICAO_OCORRENCIA)}
              />
              
            </div>
            <div>
              <TextField
                label="Existe ocorrência"
                value={getValue(data?.INDICIO_SINISTRO.EXISTE_OCORRENCIA)}
              />
              
        
            </div>
          </section>
        </Panel>
      )} 
    </Panel>
  )
}